export const HeaderChatPopoverTestIds = {
  NOTIFICATIONS_TOGGLE: 'header-chat.notifications-button',
  SOUND_TOGGLE: 'header-chat.sound-button',
  SEARCH: 'header-chat.search-input',
  OPEN_LOAN: 'header-chat.open-loan-button',
  PIN: 'header-chat.pin-button',
  VIEW_ALL: 'header-chat.view-all-button',
};
